import * as yup from "yup";

export const ReturnValidationSchema = yup.object().shape({
    chalan: yup
        .object()
        .shape({
            id: yup.number().required("Chalan is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select Chalan"),
    return_date: yup.date().required("Return date is Required").nullable(),
    return_items: yup.array().of(
        yup.object().shape({
            stock: yup.object().shape({
                id: yup.number().required("Stock is Required"),
                name: yup.string(),
                label: yup.string(),
            })
            .typeError("Please select Stock from dropdown"),
            brand: yup.object().shape({
                id: yup.number().required("Brand is Required"),
                name: yup.string(),
                label: yup.string(),
            })
            .typeError("Please select Brand from dropdown"),
            return_quantity: yup.number().required("Return quantity is Required"),
            reason: yup.string().required("Reason is Required"),
        })
    ),
});
